import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useAuth } from 'context/auth/AuthContext';

function UserRoute({ component: Component, ...rest }) {
  const user = useAuth();
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        )
      }
    />
  );
}

export default UserRoute;
